var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInCarNavigationMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.1630859,44C23.4189453,44,22,42.5810547,22,40.8369141V26H7.1630859C5.4189453,26,4,24.5810547,4,22.8369141 c0-1.2060547,0.6699219-2.2900391,1.7490234-2.8291016L41.0400391,2.3613281c0.0004883,0,0.0009766,0,0.0014648-0.0009766 C41.515625,2.125,42.0449219,2,42.5727539,2C44.4624023,2,46,3.5371094,46,5.4267578 c0,0.5292969-0.125,1.0595703-0.3618164,1.5332031L27.9921875,42.2519531C27.453125,43.3300781,26.3691406,44,25.1630859,44z  M41.9345703,4.1503906L6.6430664,21.796875C6.2460938,21.9951172,6,22.3935547,6,22.8369141 C6,23.4785156,6.5219727,24,7.1630859,24H22c1.1030273,0,2,0.8974609,2,2v14.8369141C24,41.4785156,24.5219727,42,25.1630859,42 c0.4433594,0,0.8417969-0.2460938,1.0400391-0.6425781L43.8491211,6.0654297C43.9477539,5.8681641,44,5.6474609,44,5.4267578 C44,4.6396484,43.3598633,4,42.5727539,4C42.3530273,4,42.1328125,4.0517578,41.9345703,4.1503906L41.9345703,4.1503906z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInCarNavigationMedium);
export default __webpack_public_path__ + "static/media/in-car-navigation--medium.0e2054e5c763f8b295c62d9fa43956a8.svg";
export { ForwardRef as ReactComponent };